import React from 'react';

import type { SimpleIconInterface } from './icon-utils';
import { IconColors, SimpleIcon } from './icon-utils';

export function DocumentSearchIcon({
  className,
  dataCy,
  fill = IconColors.DarkGrey,
  height = 16,
  stroke,
  strokeLinecap,
  strokeLinejoin,
  strokeWidth,
  style,
  width = 16,
}: SimpleIconInterface): JSX.Element {
  return (
    <SimpleIcon
      className={className}
      dataCy={dataCy}
      fill="none"
      height={height}
      stroke={stroke ?? fill}
      strokeLinecap={strokeLinecap ?? 'round'}
      strokeLinejoin={strokeLinejoin ?? 'round'}
      strokeWidth={strokeWidth}
      style={style}
      viewBoxDimensions="0 0 100 100"
      width={width}
    >
      <path d="M60.771 57.847V83.175C60.7711 83.4049 60.726 83.6325 60.6381 83.845C60.5502 84.0574 60.4213 84.2505 60.2588 84.4131C60.0963 84.5757 59.9033 84.7047 59.6909 84.7927C59.4785 84.8807 59.2509 84.926 59.021 84.926H11.751C11.2866 84.926 10.8412 84.7415 10.5129 84.4131C10.1845 84.0847 10 83.6394 10 83.175V23.411C10 22.9466 10.1845 22.5012 10.5129 22.1728C10.8412 21.8445 11.2866 21.66 11.751 21.66H35.107" />
      <path d="M19.396 34.708H30.697" />
      <path d="M19.396 42.879H32.449" />
      <path d="M19.396 51.216H38.49" />
      <path d="M19.396 59.19H52.046" />
      <path d="M19.396 67.527H52.046" />
      <path d="M19.396 75.501H52.046" />
      <path d="M68.473 20.878C71.2442 23.6491 73.1315 27.1798 73.8962 31.0236C74.6608 34.8674 74.2685 38.8515 72.7687 42.4723C71.269 46.0931 68.7293 49.1878 65.4707 51.3652C62.2121 53.5425 58.3811 54.7046 54.462 54.7046C50.5429 54.7046 46.7118 53.5425 43.4533 51.3652C40.1947 49.1878 37.6549 46.0931 36.1552 42.4723C34.6555 38.8515 34.2631 34.8674 35.0278 31.0236C35.7924 27.1798 37.6797 23.6491 40.451 20.878C44.167 17.1622 49.2069 15.0746 54.462 15.0746C59.7171 15.0746 64.757 17.1622 68.473 20.878Z" />
      <path d="M64.5809 24.77C66.5821 26.7713 67.9449 29.3211 68.497 32.0969C69.049 34.8728 68.7656 37.75 67.6825 40.3648C66.5994 42.9795 64.7652 45.2144 62.412 46.7868C60.0587 48.3591 57.2921 49.1984 54.4619 49.1984C51.6317 49.1984 48.865 48.3591 46.5117 46.7868C44.1585 45.2144 42.3243 42.9795 41.2412 40.3648C40.1581 37.75 39.8747 34.8728 40.4268 32.0969C40.9788 29.3211 42.3417 26.7713 44.3429 24.77C45.6717 23.4411 47.2492 22.3869 48.9855 21.6677C50.7217 20.9485 52.5826 20.5784 54.4619 20.5784C56.3412 20.5784 58.202 20.9485 59.9383 21.6677C61.6745 22.3869 63.252 23.4411 64.5809 24.77Z" />
      <path d="M88.7098 62.91C89.1187 63.3189 89.443 63.8043 89.6643 64.3385C89.8856 64.8727 89.9995 65.4453 89.9995 66.0235C89.9995 66.6017 89.8856 67.1743 89.6643 67.7085C89.443 68.2427 89.1187 68.7281 88.7098 69.137C88.3009 69.5459 87.8155 69.8702 87.2813 70.0915C86.7471 70.3128 86.1745 70.4267 85.5963 70.4267C85.0181 70.4267 84.4455 70.3128 83.9113 70.0915C83.3771 69.8702 82.8917 69.5459 82.4828 69.137L72.4498 59.1C72.0142 58.6644 71.7695 58.0736 71.7695 57.4575C71.7695 56.8415 72.0142 56.2506 72.4498 55.815L75.3918 52.873C75.6074 52.6571 75.8634 52.4858 76.1453 52.3689C76.4271 52.2521 76.7292 52.1919 77.0343 52.1919C77.3394 52.1919 77.6415 52.2521 77.9234 52.3689C78.2052 52.4858 78.4612 52.6571 78.6768 52.873L88.7098 62.91Z" />
      <path d="M62.793 28.2L62.791 41.384" />
      <path d="M69.9438 47.257L75.4778 52.791" />
      <path d="M72.3651 55.905L66.8311 50.371" />
    </SimpleIcon>
  );
}
